module.exports = __webpack_public_path__ + "img/celebrate.54e0988d.jpg";